import { useStore } from 'vuex';
import { dataProvider } from "@/api/dataProvider.js";

let ccOnEmailsCacheOrPromise = null;

export function useCCOnEmails() {
  const store = useStore();

  async function ccOnEmails(forceRefresh = false) {
    if (ccOnEmailsCacheOrPromise && !forceRefresh) {
      return ccOnEmailsCacheOrPromise;
    }

    ccOnEmailsCacheOrPromise = (async () => {
      const ccEnabled = await dataProvider.getColumnSetting("CcMeOnEmails");
      const ccAdditionalAddrEnabled = await dataProvider.getColumnSetting("IsCCAdditionalAddresses");
      let emailList = [];

      if (ccEnabled.SettingValue == 1) {
        const userEmails = store.state.login.emailID
          .split(",")
          .map((email) => email);
        emailList.push(...userEmails);
      }

      if (ccAdditionalAddrEnabled.SettingValue == 1) {
        const ccAddresses = await dataProvider.getColumnSetting("AdditionalCcAddresses");
        const additionalEmails = JSON.parse(ccAddresses.SettingValue);
        emailList.push(...additionalEmails);
      }

      const result = [...new Set(emailList.map(email => email.toLowerCase().trim()))];
      ccOnEmailsCacheOrPromise = result;
      return result;
    })();

    return ccOnEmailsCacheOrPromise;
  }

  function clearCcOnEmailsCache() {
    ccOnEmailsCacheOrPromise = null;
  }

  return { ccOnEmails, clearCcOnEmailsCache };
}